var path = 'components/displayCondition/details/valueList/valueList.html';
var html = "<div> <strong>{{values.length > 1 ? 'Werte' : 'Wert'}}:</strong> {{values.join(', ')}} </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;